import { LayoutAction } from "./types";

export class InvalidLayoutActionError extends Error {
  constructor() {
    super("Invalid layout action");
  }
}

export class MissingLayoutId extends Error {
  constructor() {
    super("No Layout ID provided");
  }
}

export class LocalError extends Error {
  action: LayoutAction;

  constructor(action: LayoutAction) {
    super("Local error: " + JSON.stringify(action));
  }
}

export class RemoteError extends Error {
  action: LayoutAction;
  constructor(action: LayoutAction) {
    super("Remote error: " + JSON.stringify(action));
  }
}

export class AnimatorError extends Error {
  constructor() {
    super("Animations must have an origin or destination");
  }
}
